import axios from "axios";
import { jwtDecode } from "jwt-decode";
import createStore from "react-auth-kit/createStore";
import createRefresh from "react-auth-kit/createRefresh";

export const refresh_api = {
  interval: 14 * 60, // The time in sec to refresh the Access token,
  refreshApiCallback: async (param: any) => {
    try {
      const response = await axios.get("/api/auth/refresh", {
        headers: { Authorization: `Bearer ${param.authToken}` },
      });
      const decoded = jwtDecode(response.data.accessToken);
      const rfdecoded = jwtDecode(response.data.refreshToken);
      console.log("Refreshing");
      return {
        isSuccess: true,
        newAuthToken: response.data.accessToken,
        newAuthTokenExpireIn: decoded.exp! - decoded.iat!,
        newRefreshTokenExpiresIn: rfdecoded.exp! - rfdecoded.iat!,
      };
    } catch (error) {
      console.error(error);
      return {
        isSuccess: false,
        newAuthToken: "",
      };
    }
  },
};

export const store = createStore<any>({
  authName: "_auth",
  authType: "cookie",
  cookieDomain: window.location.hostname,
  cookieSecure: window.location.protocol === "https:",
  refresh: refresh_api,
});
